'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'chevrons-up';
var width = 448;
var height = 512;
var aliases = ["chevron-double-up"];
var unicode = 'f325';
var svgPathData = 'M230 34.3l-5.7-5.7-5.7 5.7-216 216-5.7 5.7 11.3 11.3 5.7-5.7 210.3-210.3 210.3 210.3 5.7 5.7 11.3-11.3-5.7-5.7-216-216zm0 192l-5.7-5.7-5.7 5.7-216 216-5.7 5.7 11.3 11.3 5.7-5.7 210.3-210.3 210.3 210.3 5.7 5.7 11.3-11.3-5.7-5.7-216-216z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;